export const billingPreviewQuery = `
  query BillingPreview($input: BillingPreviewInput!) {
    billingPreview(input: $input) {
      code
      preview {
        billingPeriodId
        dueDate
        studentCount
        totalAmount
        lines {
          studentId
          studentCode
          studentName
          totalAmount
          items {
            feeStructureId
            description
            amount
          }
        }
      }
    }
  }
`;

export const postStudentBillsQuery = `
  mutation PostStudentBills($input: PostStudentBillsInput!) {
    postStudentBills(input: $input) {
      code
      result {
        postedCount
        postedBills {
          studentId
          orderId
          orderNumber
          invoiceId
          invoiceNumber
        }
      }
    }
  }
`;

export const listStudentInvoicesQuery = `
  query ListStudentInvoices($input: ListStudentInvoicesInput!) {
    listStudentInvoices(input: $input) {
      code
      invoices {
        invoiceId
        invoiceNumber
        orderNumber
        studentId
        totalAmount
        paidAmount
        remainingAmount
        status
        issueDate
        dueDate
      }
      totalElements
    }
  }
`;

export const listOverdueInvoicesQuery = `
  query ListOverdueInvoices($input: ListOverdueInvoicesInput) {
    listOverdueInvoices(input: $input) {
      code
      invoices {
        invoiceId
        invoiceNumber
        studentId
        totalAmount
        remainingAmount
        dueDate
        status
      }
      totalElements
    }
  }
`;

export const listOverdueEducationInvoicesQuery = `
  query ListOverdueEducationInvoices($input: ListOverdueInvoicesInput) {
    listOverdueEducationInvoices(input: $input) {
      code
      invoices {
        invoiceId
        invoiceNumber
        studentId
        totalAmount
        remainingAmount
        dueDate
        status
      }
      totalElements
    }
  }
`;

export const educationFeeSummaryQuery = `
  query EducationFeeSummary {
    educationFeeSummary {
      code
      totalCollected
      totalOutstanding
      feeBillCount
      overdueCount
    }
  }
`;
